import { render, staticRenderFns } from "./IcoArrowUp.vue?vue&type=template&id=1a79f609"
import script from "./IcoArrowUp.vue?vue&type=script&lang=js"
export * from "./IcoArrowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports